module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("F")]), _vm._v("ive")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('hr', {
    staticClass: "hr"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AN YOU MEET ME")]), _vm._v(" for lunch?” Nicci said on her cell phone, still driving.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not eating,” Saffron replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“ ’Cause I’m fat.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re a size four,” Nicci pointed out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m zeroing in on a size two.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get a life, girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have you "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("seen")]), _vm._v(" Calista Flockhart and Lara Flynn Boyle? That’s my goal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, to be white and skinny,” Nicci said scathingly, glancing at a passing stud on a Harley, while almost rear-ending an uptight face-lift in a cream Bentley. “Anyway, you "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("have")]), _vm._v(" to meet me for lunch, it’s urgent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Does it concern a prenup?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“What")]), _vm._v(" prenup?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The one he’s gonna make you sign.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("“Evan will "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("not")]), _vm._v(" make me sign anything,” Nicci said haughtily. “I think you’re forgetting we’re in love.”")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ha!” Saffron exclaimed rudely. “So were Sly Stallone and Michael Douglas at one time, an’ look what happened to "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("them.")]), _vm._v(" Man, did "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("they")]), _vm._v(" get a blast of the first-wife blues!” A beat. “Evan’s lawyer will "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("never")]), _vm._v(" let him marry you without a prenup. So get ready.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicci realized there was no use arguing with Saffron when she was on a roll. “Meet me at Fred Segal in half an hour,” she said. “And try not to be late.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Only if you "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("promise")]), _vm._v(" you’ll let no food pass my lips.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“See ya.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicci had decided to hand over responsibility for the bridesmaids’ dresses to Saffron. She could handle it, she had nothing else to do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It did not occur to Nicci that she had nothing else to do either; that wasn’t the point.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reaching for a cigarette, she zoomed off down Melrose.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AYLOR")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INGER")]), _vm._v(" parked on the street in Venice, reluctantly, because she was a valet parker addict and hated having to walk anywhere. Locking her Jaguar, she headed down a narrow side street that led directly to the beach.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Christ!")]), _vm._v(" she thought. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("If my car is stolen, how do I explain what I’m doing in this seedy neighborhood?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No explanations necessary. Larry trusted her. He loved her. He would "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("never")]), _vm._v(" believe she would betray him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet that’s exactly what she was doing. Betraying him big time. She simply couldn’t help herself.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("Her high heels clicked along the street until she reached the entrance to a run-down apartment complex painted a particularly sickening shade of orange.")])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Producing a key from her Hermès Kelly bag, she let herself in the side door, which led to an open overgrown courtyard. There were four apartments in the complex, and she headed to the farthest one. The door was open. Oliver was expecting her. Her skin began tingling in anticipation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oliver Rock. Twenty-two years old. A long-haired, skinny screenwriter who’d yet to sell a script.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oliver Rock. Her first cheat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’d been recommended to her by an agent who’d suggested her script needed to skewer younger. “Go see Oliver,” the agent had said. “He’s gonna be big. Get in at the beginning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She’d gotten in all right. She’d been getting in for three weeks and couldn’t get enough of him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She entered the small, messy apartment. The living room smelled of cat piss and pot, even though the windows, which overlooked the ocean, were wide open. A word processor stood on a rickety wooden table. Loud rap played on the compact sound system.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Taylor took a deep breath, shut the door behind her and locked it. “Oliver?” she called.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No answer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shrugging off her jacket, she put down her bag and stepped out of her shoes. Then she unzipped her skirt, unbuttoned her blouse, and walked into the bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oliver was sprawled on a mattress on the floor, asleep. He didn’t believe in traditional sleeping arrangements, or maybe he couldn’t afford a proper bed. She didn’t know and she didn’t care. Conversation was not their strong suit.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("For six years she’d been faithful to a man who was not a sexual being. Larry tried, but in the sex stakes he was a loser.")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Now, with Oliver, she’d finally found her sexual soul mate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And even though it was dangerously beyond her control, she was totally helpless, and there was absolutely nothing she could do about it.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICCI WAS ALREADY")]), _vm._v(" settled at an outdoor table when Saffron turned up half an hour late. Saffron was an exotic treat with her finely chiseled features, milk-chocolate skin, gold nose ring, long black dreadlocks, and sinuous body. Heads swiveled to watch her as she wafted to the table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Greetings, O Pale One,” Saffron said, oblivious to the stares. “You been considering what I said?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” Nicci retorted. “And I am like "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("so not")]), _vm._v(" pale. I’ve got the best tan I’ve ever had.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bad for the skin, all that lying out burning your body,” Saffron remarked, sitting down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine for you to say with your natural year-round milk-chocolate thing going.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wanna swap?” Saffron said, amused.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wanna get serious?” Nicci retorted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Saffron stretched sensuously, almost causing a businessman at the next table to choke on his steak. “Tell me what’s on your mind?” she inquired.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I need you to take care of the bridesmaids’ dresses,” Nicci said crisply. “Y’know, order them, like get them made in time, see that they fit. All that kind of stuff.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Me?”")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("“No,” Nicci said, rolling her eyes in exasperation. “That guy sitting over there.”")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Isn’t your "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("mom")]), _vm._v(" supposed to be taking care of all the details?” Saffron said, reaching for a bread roll.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("mom")]), _vm._v(" is taking care of the bills,” Nicci said, slapping her friend’s hand away from the bread. “And I have like a thousand other things to organize. So "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("please,")]), _vm._v(" Saffy, do me this one minor favor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hmm . . . I suppose if you like "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("insist,”")]), _vm._v(" Saffron said. “But only if you call the waiter over right "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("now")]), _vm._v(" before I "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("starve")]), _vm._v(" to death.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought you weren’t eating.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If I’m working then I’m eating,” Saffron said, picking up the menu. “Spaghetti and meatballs. Yum. And carrot cake for dessert. Girl, I need all the energy I can get.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re amazing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know,” Saffron agreed, with a Cheshire cat grin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They’d been friends since childhood, sharing the common bond of having very famous mothers. And since their mothers were also good friends, they’d gotten to spend plenty of time together. Saffron had even visited with Nicci when she’d lived in Spain. They’d had a fine time running riot with no adults to tell them what not to do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wassup?” Saffron asked. “Anything I should know about?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicci shrugged. “I’m getting married. Isn’t that enough?”")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISSA FOUND HERSELF")]), _vm._v(" sitting up straighter. “So I finally get to meet you,” she said. “Quincy’s talked about you a lot.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("“Quincy loves telling stories from the old days,” Michael said with a wry grin. “Like how I got shot, huh?”")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think he told me about that,” she murmured, continuing to check him out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Damn! He was good looking. She’d worked with plenty of handsome actors, but this guy was exceptional.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s go in my office,” he suggested, rubbing his faintly stubbled chin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She got up and followed him into a big comfortable room next to Quincy’s. There was a worn leather desk, two chairs, a TV, and stereo equipment. A framed print of a classic Ferrari hung on the wall next to a black-and-white picture of him and Quincy taken outside their precinct station in New York.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Take a seat,” he said, trying not to stare. Her movies and videos did not do her justice, this was one breathtaking woman. “An’ I hate to do this,” he added. “Only I gotta run to the john.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go ahead,” she said, slightly amused.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He left her sitting there. Noticing a framed photograph on his desk, she leaned forward and took a surreptitious peek. The frame contained a photo of a pretty young girl.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She glanced around to see if she could spot a picture of his wife.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("This is a twist,")]), _vm._v(" she thought. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Here I am visiting an investigator about my cheating husband, and I’m checking to see if he has a picture of his wife on the desk.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Removing her baseball cap she shook out her platinum hair and took a long deep breath. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Let’s get this over with,")]), _vm._v(" she thought. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I have to know.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("Michael reentered the room, immediately noticing that with her silky hair framing her oval-shaped face she ")]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("was even more stunning. “Sorry about that,” he said briskly. “Been out all morning, couldn’t take a break.” He settled behind his desk. “Well, uh, Miss Roman.”")])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Call me Lissa,” she said, suddenly feeling unbearably tense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He caught her vibes and sympathized. “This is an awkward situation, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, it is,” she agreed. “I had to get the proof, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s the smart way of looking at it,” he said, craving a cigarette, but determined not to light up in front of her. “Now,” he said, getting down to business. “I’m not gonna bore you with details, so how about I play you one of the tapes?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What tapes?” she said quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I tapped into your husband’s cell phone. It’s the quickest way of catching someone. So what you’re about to hear is a conversation he had yesterday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see,” she said, resigning herself to the worst.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Want me to wait outside while you listen?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ve already heard it, haven’t you?” she said, making an effort to stay in control. It was bad enough doing this, she had no intention of turning into the poor wronged little woman—not her image at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Uh . . . yes,” Michael said. He’d listened to all the tapes, and they were pretty raunchy. The tape he was about to play for her was one of the milder ones.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then there’s no reason we shouldn’t listen together,” she said coolly. “It’ll be our entertainment for the afternoon. Big movie star listening to her husband cheat, because that’s what I’m about to hear, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” he shrugged. “You wanted the information.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” she said, shrugging back. “Guess I’ve got it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t be mad at "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("me,”")]), _vm._v(" he said, reaching for the cassette on his desk. “I’m the bearer, not the doer.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("“I’m not mad,” she said resignedly. “Merely disappointed.”")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can understand that,” he said, getting up and heading for the tape player.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, Michael,” she said, making conversation. “Quincy mentioned you’re from New York.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“New York born,” he replied. “Although my grandparents were Sicilian. Moved out here six years ago, reconnected with Quincy an’ never regretted it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Quincy’s a nice man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The best.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you like living in L.A.?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s different. Yeah, I like it,” he said, slipping the cassette into the machine. “The weather. The easy lifestyle.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is that your little girl?” she asked, pointing to the picture on his desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Uh . . . no,” he said, hesitating for a moment, his black eyes clouding over. “That’s Bella, my niece.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s a beauty.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think so,” he said, pressing "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PLAY.")]), _vm._v(" “Okay, Lissa, here we go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She waited. And then she heard them, Gregg, putting on his so-called sexy voice, and a breathy-sounding female.")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "line_20"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REGG:")])])]), _vm._v(" "), _c('td', {
    staticClass: "line_70"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Hello, baby.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "line_20"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRL:")])])]), _vm._v(" "), _c('td', {
    staticClass: "line_70"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("I missed you after you left last night. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("(A dirty giggle.)")]), _vm._v(" You’re the best sex I ever had.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "line_20"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REGG:")])])]), _vm._v(" "), _c('td', {
    staticClass: "line_70"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("C’mon, you’re only saying that to get me hard again. And believe me, it doesn’t take much.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "line_20"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRL:")])])]), _vm._v(" "), _c('td', {
    staticClass: "line_70"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("You’re "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("the")]), _vm._v(" best lover in the world. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("(A languid pause.)")]), _vm._v(" And . . . you have "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("the")]), _vm._v(" most beautiful cock.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "line_20"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REGG:")])])])]), _vm._v(" "), _c('td', {
    staticClass: "line_70"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("That’s something my wife never tells me.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "line_20"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRL:")])])]), _vm._v(" "), _c('td', {
    staticClass: "line_70"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("That’s ’cause she never sees it. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("(This time a knowing giggle.)")]), _vm._v(" Right, honeybunch?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "line_20"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REGG:")])])]), _vm._v(" "), _c('td', {
    staticClass: "line_70"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Listen, uh . . . I’ll try and get there by eight. I’m telling Lissa I’m working late again.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "line_20"
  }, [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GIRI.:")])])]), _vm._v(" "), _c('td', {
    staticClass: "line_70"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Does she honestly buy that tired old excuse?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "line_20"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REGG:")])])]), _vm._v(" "), _c('td', {
    staticClass: "line_70"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("She buys anything I sell her.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "line_20"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRL:")])])]), _vm._v(" "), _c('td', {
    staticClass: "line_70"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("How dumb.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "line_20"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REGG:")])])]), _vm._v(" "), _c('td', {
    staticClass: "line_70"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("That’s my wife. She’s too busy being famous to notice anything.")]), _vm._v(" "), _c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("They both laughed.")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, enough!” Lissa said abruptly, her cheeks flushed with anger. “I don’t need to hear any more.” She was furious and embarrassed. Why did this always happen to her? What had she done to deserve it?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Michael clicked the machine off. “Some men never learn,” he said ruefully. “This one must be a real loser.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Some women never learn either,” she said sadly. “Gregg’s my fourth husband. All four of them cheated on me. How’s that for a track record?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now why was she telling a total stranger her business? God! She was pathetic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Michael shrugged. “It’s a question of finding the right person. When you do, you’ll know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How?” she asked wryly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The trick is never to settle for second best—or so I’ve heard.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She gazed at him intently, wondering what was going through his head. “Is that what you imagine "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I")]), _vm._v(" did?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hardly know you, Lissa,” he said slowly, trying not to stare into her blue-diamond eyes. “So I can’t answer that question.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("“How many times have "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("you")]), _vm._v(" been married?” she ")]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("asked, certain that his track record wasn’t so great either.")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Once,” he said grimly. “That was enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sounds ominous.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No reason to get married unless you want kids. You got any?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A daughter,” she answered restlessly. “Had her when I was twenty—that’s too young to be a mom. Makes me feel ancient now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You—ancient?” he said, raising his eyebrows in surprise. “You’re one of the most beautiful women in the world.” "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Christ!")]), _vm._v(" he thought. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I sound like a freakin’ fan. I’d better get it together here.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now you’re embarrassing me,” she murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Their eyes met for a few seconds. It was an intimate look for two people who hardly knew each other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abruptly Michael broke the look and got up from behind his desk. “Do you want copies of the tapes?” he asked. “We usually store the originals in the safe, but I made copies in case you need them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have to figure out how to handle this,” she said, trying to sound like she knew what she was doing. “I’d better speak to my lawyer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s a plan,” he said, handing her several cassettes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She reached for her purse and stood up. “Uh . . . Michael,” she said hesitantly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who’s the woman on the tape?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He took a moment before answering, then he said, “A salesgirl at Barneys.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("“Oh,” she said, wishing she hadn’t asked. Damn Gregg. The fact that she was Lissa Roman obviously didn’t do it for him. He had to turn to a salesgirl at Bar")]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("neys to get the sex he was denying her, because the truth was they hadn’t slept together in over a month.")])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, screw him, he wasn’t getting one red cent of her hard-earned money. She’d fight him all the way if he tried to overturn the prenuptial.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unexpected tears filled her eyes, and she hurriedly put on her shades.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is your husband leaving town anytime soon?” Michael asked, pretending not to notice she was close to tears.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?” she asked, regaining her composure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He felt sorry for her and protective all at the same time. She might be an enormous star, but she was still a woman in pain, and he had an insane desire to put his arms around her and hold her close. “Well,” he said, “if he’s out of town, or even gone for the day, I can arrange to have all his possessions packed up and the locks on your house changed. That way, when he comes home, there’ll be a lawyer’s letter waiting outside the door asking where he’d like his stuff delivered, and you don’t have to see him. It’s a done deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("you")]), _vm._v(" organize it for me?” she asked hopefully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you tell me when he’ll be away.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s supposed to be recording with a new producer all day Friday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s two days down the line. You certain you can hold it together until then?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m an actress,” she said confidently. “Gregg will never suspect a thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not so sure,” Michael said. “Living in the same house, pretending nothing’s going on. It won’t be easy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t worry about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("am")]), _vm._v(" worried,” he said, frowning. “What if you can’t hold back and get into a fight?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("“I won’t do that,” she promised.")])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Has he ever been violent toward you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” she lied, conveniently forgetting two extremely disturbing incidents she preferred to block out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you say so,” Michael said reluctantly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay. I’ll take care of everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks,” she murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All you have to do is call me when he leaves the house on Friday.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll make it smooth and easy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re very nice, Michael.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His look was direct and disconcerting. “That’s because I’m dealing with a very nice lady.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5b49aaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch05.vue
// module id = 87
// module chunks = 0